<div class="message" [ngClass]="type">
  <div class="message__content">
    <!-- Header template OR header input -->
    <div class="message__content__header" *ngIf="headerTpl || title">
      <ng-container *ngIf="headerTpl; else inputHeader">
        <ng-container *ngTemplateOutlet="headerTpl"></ng-container>
      </ng-container>
      <ng-template #inputHeader>
        <span *ngIf="icon" class="material-icons-outlined">{{ icon }}</span>
        <h2>{{ title }}</h2>
      </ng-template>
    </div>

    <div class="message__content__body">
      <ng-content></ng-content>
    </div>

    <!-- Optional footer -->
    <div class="message__content__footer" *ngIf="footerTpl">
      <ng-container *ngTemplateOutlet="footerTpl"></ng-container>
    </div>
  </div>
</div>
